import * as React from "react";
import { cn } from "../../lib/utils";

const ICON_STROKE = 1.75;

const Icon = ({ icon: IconComponent, size = 24, className, label, ...props }) => {
  if (!IconComponent) return null;
  return (
    <IconComponent
      size={size}
      strokeWidth={ICON_STROKE}
      className={cn("shrink-0", className)}
      aria-hidden={!label}
      aria-label={label}
      {...props}
    />
  );
};

export { Icon, ICON_STROKE };
